var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51902 0.925781C6.34958 0.925781 7.05977 1.65176 7.05977 2.50078V6.01117C7.65912 5.43671 8.80936 5.36619 9.5539 6.23262C10.3565 5.7303 11.4178 6.15714 11.7447 6.81094C13.4723 6.49545 14.25 7.58248 14.25 9.36328C14.25 9.45982 14.2429 9.83002 14.2431 9.92578C14.2491 12.1044 13.151 12.6291 12.8961 14.2757C12.8326 14.6861 12.4781 14.9883 12.0628 14.9883H6.03261L6.03258 14.9882C5.3869 14.9878 4.77086 14.6153 4.49115 13.9875C4.03433 12.972 2.76716 10.6332 1.77277 10.207C1.1331 9.93292 0.750281 9.45525 0.75 8.80078C0.749508 7.59766 1.98391 6.77044 3.10223 7.24972C3.39611 7.37569 3.68829 7.54194 3.97826 7.74729V2.50078C3.97826 1.67637 4.70047 0.925781 5.51902 0.925781ZM5.53125 15.5508H12.2812C12.7472 15.5508 13.125 15.9285 13.125 16.3945V18.082C13.125 18.548 12.7472 18.9258 12.2812 18.9258H5.53125C5.06525 18.9258 4.6875 18.548 4.6875 18.082V16.3945C4.6875 15.9285 5.06525 15.5508 5.53125 15.5508ZM11.4375 16.5352C11.0492 16.5352 10.7344 16.8499 10.7344 17.2383C10.7344 17.6266 11.0492 17.9414 11.4375 17.9414C11.8258 17.9414 12.1406 17.6266 12.1406 17.2383C12.1406 16.8499 11.8258 16.5352 11.4375 16.5352Z",
    fill: "#7E7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePicker);
export default __webpack_public_path__ + "static/media/TimePicker.4515f30c072bec4ccd87796cf06ececc.svg";
export { ForwardRef as ReactComponent };